import isEmpty from 'lodash/isEmpty'
import { buildVariables } from 'ra-data-hasura'

import { getQuery } from './queries/customQueryFormatter'

const customBuildVariables =
  (introspectionResults) => (resource, aorFetchType, params, queryType) => {
    const filter = params.filter

    if (process.env.REACT_APP_CUSTOM_QUERIES) {
      const resourceName = resource.name
      console.log(
        `customBuildVariables introspectionResults ${JSON.stringify(
          introspectionResults
        )}`
      )
      console.log(
        `customBuildVariables resourceName ${JSON.stringify(resourceName)}`
      )
      console.log(
        `customBuildVariables aorFetchType ${JSON.stringify(aorFetchType)}`
      )
      console.log(`customBuildVariables resource ${JSON.stringify(resource)}`)
      console.log(`customBuildVariables queryType ${JSON.stringify(queryType)}`)
      console.log(`customBuildVariables params ${JSON.stringify(params)}`)
      console.log(
        `customBuildVariables params.filters ${JSON.stringify(filter)}`
      )
    }

    if (filter) {
      // get already built query
      let completeFilters = filter.clause
      // check for properties that should be mapped into a query (i.e those comming from a search)
      const arr = Object.entries(filter).reduce((acc, entry) => {
        const [key, value] = entry

        if (key.startsWith('QF') || key.startsWith('ASSIGNED_TO')) {
          acc.push(
            getQuery([
              {
                name: key.startsWith('QF') ? key : 'ASSIGNED_TO',
                values: {
                  value,
                },
              },
            ])?.clause
          )
        } else {
          completeFilters = {
            ...completeFilters,
            ...getQuery([
              {
                name: key,
                values: {
                  value,
                },
              },
            ])?.clause,
          }
        }

        return acc
      }, [])

      // generate an array with the filter objects that have an or condition
      let orClause = completeFilters?._or || []
      orClause = orClause.concat(arr)
      completeFilters = {
        ...completeFilters,
        _or: orClause.length > 0 ? orClause : {}, //_or cannot be an empty string or it'll not return anything
      }
      // if we made a custom filter, build and return it
      if (!isEmpty(completeFilters)) {
        const where = { where: { ...completeFilters, ...params.where } }
        if (params.pagination) {
          where['limit'] = params.pagination.perPage
          where['offset'] =
            params.pagination.perPage * (params.pagination.page - 1)
        }
        if (params.sort && Object.keys(params.sort)) {
          where['order_by'] = {
            [params.sort.field]: params.sort.order.toLowerCase(),
          }
        }
        return where
      }
    }

    if (params.where) {
      const pagination = params.pagination
        ? {
            limit: params.pagination.perPage,
            offset: params.pagination.perPage * (params.pagination.page - 1),
          }
        : {}
      return { where: params.where, ...pagination }
    }

    // else, return the default query constructor
    const result = buildVariables(introspectionResults)(
      resource,
      aorFetchType,
      params,
      queryType
    )

    if (process.env.REACT_APP_CUSTOM_QUERIES) {
      console.log(`customBuildVariables result ${JSON.stringify(result)}`)
    }

    return result
  }

export default customBuildVariables
